/**
 * @requires ./frc.js
 */

 // Tags based on https://docs.google.com/spreadsheets/d/1kAJyIdp68PSdBhD2B504nR8ChidNE2MlekNTeEXIPoU/edit#gid=551160073

frc.analytics = {
    "config": {
        "locations": {
            "f8169eae-b29e-11e7-83fc-33060029d6a5": { // Houston
                "mathTag": {
                    "pageLoad": "1175961",
                    "reserve": "1175962"
                }
            },
            "e1407128-a9fc-11e7-8ff9-4f5dd4fdf7c4": { // Austin (Domain)
                "mathTag": {
                    "pageLoad": "1175963",
                    "reserve": "1175964"
                }
            },
            "170b2e10-3225-11e7-a1a9-73557804d3fb": { // El Segundo
                "mathTag": {
                    "pageLoad": "1175965",
                    "reserve": "1175966"
                }
            },
            "73a54e44-b29f-11e7-9430-575b91de548f": { // Scottsdale
                "mathTag": {
                    "pageLoad": "1175967",
                    "reserve": "1175968"
                }
            },
            "500c4004-b2a0-11e7-9438-6fd1ad1f0f38": { // Phoenix (Arcadia)
                "mathTag": {
                    "pageLoad": "1175969",
                    "reserve": "1175970"
                }
            },
            "1c429f62-b29f-11e7-83fe-8bab942fdcfc": { // Irvine
                "mathTag": {
                    "pageLoad": "1175971",
                    "reserve": "1175972"
                }
            },
            "d865d4b2-b29e-11e7-8fba-5b89621ce7c1": { // Santa Monica
                "mathTag": {
                    "pageLoad": "1189750",
                    "reserve": "1189751"
                }
            },
            "c46109f0-b29e-11e7-83fa-d385bcf5ce01": { // Plano
                "mathTag": {
                    "pageLoad": "1268134",
                    "reserve": null
                },
                "dataXu": {
                    "pageLoad": "<img src=\"https://tags.w55c.net/rs?id=34eb59f1a82c44139c789213000d40ee&t=marketing\" />"
                }
            },
            "6401b8ec-b29f-11e7-b283-bb0fa1ccad97": { // Kansas (Leawood)
                "mathTag": {
                    "pageLoad": "1269332",
                    "reserve": null
                }
            },
            "03b99cc0-a9fd-11e7-8cfc-d31ba5693843": { // Denver
                "mathTag": {
                    "pageLoad": "1269330",
                    "reserve": null
                }
            },
            "7da53eda-b2a0-11e7-9bfc-a71881978e93": { // Las Vegas (Summerlin)
                "mathTag": {
                    "pageLoad": "1269331",
                    "reserve": null
                }
            }
        }
    },
    "init": function(){
        $(frc).on("locationdetailspageloaded", function(jqE, e){
            var self = frc.analytics;
            if(frcContext.environment=="PROD"){
                if(e.locationId){
                    var taggingInfo = self.config.locations[e.locationId];
                    if(taggingInfo){
                        // Fire MathTag pageload pixel for location
                        if(taggingInfo.mathTag && taggingInfo.mathTag.pageLoad){
                            self.mathTag.fire(taggingInfo.mathTag.pageLoad);
                        }

                        // Fire DataXu pageload pixel for location
                        if(taggingInfo.dataXu && taggingInfo.dataXu.pageLoad){
                            self.injectTag(taggingInfo.dataXu.pageLoad);
                        }
                    }
                }
            }
        });

        $(frc).on("reservationformsubmitted", function(jqE, e){
            var self = frc.analytics;
            if(frcContext.environment=="PROD"){
                if(e.locationId){
                    var taggingInfo = self.config.locations[e.locationId];
                    if(taggingInfo){
                        // Fire MathTag reservation pixel for location
                        if(taggingInfo.mathTag && taggingInfo.mathTag.reserve){
                            self.mathTag.fire(taggingInfo.mathTag.reserve);
                        }

                        // Fire DataXu reservation pixel for location
                        if(taggingInfo.dataXu && taggingInfo.dataXu.reserve){
                            self.injectTag(taggingInfo.dataXu.reserve);
                        }
                    }
                }
            }
        });

    },
    "injectTag": function(html){
        if(!jQuery("#analytics-tags").length){
            jQuery("<div id=\"analytics-tags\"></div>").css({
                "visibility": "hidden",
                "position": "absolute",
                "height": 0,
                "width": 0,
                "overflow": "hidden",
                "opacity": 0
            }).appendTo($("body").eq(0));
        }
        jQuery("#analytics-tags").append(html);
    },
    "mathTag": {
        "config": {
            "accountId": "157716"
        },
        "fire": function(pixelId){
            var self = frc.analytics;
            self.injectTag("<script language=\"JavaScript1.1\" async src=\"//pixel.mathtag.com/event/js?mt_id=" + pixelId + "&mt_adid=" + self.mathTag.config.accountId + "&mt_exem=&mt_excl=&v1=&v2=&v3=&s1=&s2=&s3=\"></script>");
        }
    }
}